<template>
    <div>
        <base-crud
                crudName="Ingredientes"
                newText="Novo Ingrediente"
                :table="ingredientTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="false"
                :enableEdit="false"
                :enableDelete="false"
                :enableSetStatus="true"
        >
        </base-crud>

    </div>
</template>

<script>

    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                ingredientTable: 'ingredientTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'ingredient_id', 'name', 'unit', 'quantity', 'price', 'status', 'actions'],
                tableData: [],
                options: {
                    sortable: ['id', 'recipe_id', 'name', 'status'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        'ingredient_id': 'Ingrediente',
                        'name': 'Nome',
                        'unit': 'Unidade',
                        'quantity': 'Quantidade',
                        'price': 'Preço',
                        'actions': 'Ações'
                    },
                    templates: {
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    }
                },
                endPoint: 'ingredient/'
            }
        },
        components: {
            BaseCrud
        }

    }
</script>

<style>

    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Ingredient/Crud.vue